/**
 * conso-menu-black.js
 * Black Antecipada (out/2026): o item do menu "BLACK ANTECIPADA" (link /pages/bemvindo)
 * aparece com o "BLACK" em negrito. O título vem do menu do admin como texto puro, então
 * o negrito é posto aqui, sem mexer no header base.
 *
 * Só age quando o texto contém "BLACK ANTECIPADA" ou "BLACK NOVEMBER" (nov/2026) (o que vier antes ou depois, como um
 * emoji, fica como está): se o menu voltar pra OFERTAS, nada muda.
 * O header do Horizon re-renderiza o menu (overflow-list, drawer), por isso o
 * MutationObserver. Cor e peso em conso-header-dropdown.css / conso-header-drawer.css.
 */
(function () {
  'use strict';

  var SEL = '.menu-list__link[href$="/pages/bemvindo"] .menu-list__link-title,' +
    '.menu-drawer__menu-item[href$="/pages/bemvindo"] .menu-drawer__menu-item-text';

  function aplicar() {
    document.querySelectorAll(SEL).forEach(function (el) {
      if (el.classList.contains('conso-menu-black')) return;
      var m = el.textContent.match(/^([\s\S]*?)(black)(\s+(?:antecipada|november)[\s\S]*)$/i);
      if (!m) return;
      var b = document.createElement('b');
      b.textContent = m[2];
      el.classList.add('conso-menu-black');
      el.replaceChildren(m[1], b, m[3]);
    });
  }

  function iniciar() {
    aplicar();
    var raiz = document.getElementById('header-group') || document.body;
    new MutationObserver(aplicar).observe(raiz, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
